var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("infinite-loading", {
    ref: "infiniteLoading",
    on: { infinite: _vm.infiniteHandler },
    scopedSlots: _vm._u([
      {
        key: "no-more",
        fn: function () {
          return [
            _c("div", { domProps: { textContent: _vm._s(_vm.noMoreText) } }),
          ]
        },
        proxy: true,
      },
      {
        key: "no-results",
        fn: function () {
          return [
            _c("div", {
              domProps: { textContent: _vm._s(_vm.noResultsLabel) },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }